<template>
  <div class="chat-carousel">
    <div class="chat-carousel__viewport">
      <div class="chat-carousel__track" :style="trackStyle" :class="{ 'is-static': reducedMotion }">
        <div class="chat-carousel__slide" v-for="prop in properties" :key="prop.cod_ofer">
          <!--
            Los campos del agente (PropertySummary.to_dict) coinciden con los que
            consume Property.vue; `habitaciones` ya viene resuelto, no se suma.
          -->
          <Property
            :idProp="prop.cod_ofer"
            :image="prop.foto"
            :tipo="prop.nbtipo"
            :dorm="prop.habitaciones"
            :banyos="prop.banyos"
            :sup="prop.m_cons"
            :referencia="prop.ref"
            :precioInmo="prop.precioinmo"
            :precioAlq="prop.precioalq"
            :precioCom="prop.outlet"
            :ciudad="prop.ciudad"
            :zona="prop.zona"
            :operacion="prop.keyacci"
            :numFotos="prop.numfotos"
            :colLg="12"
            :colXl="12"
          />
          <div class="chat-carousel__actions">
            <button type="button" class="chat-carousel__btn" @click="goToDetail(prop)">
              Ver ficha
            </button>
            <button type="button" class="chat-carousel__btn chat-carousel__btn--primary" @click="visit(prop)">
              Agendar visita
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Navegación por botones -->
    <div class="chat-carousel__nav" v-if="properties.length > 1">
      <button
        type="button"
        class="chat-carousel__arrow"
        :disabled="index === 0"
        @click="prev"
        aria-label="Inmueble anterior"
      >
        <span class="fa fa-chevron-left"></span>
      </button>

      <div class="chat-carousel__dots">
        <button
          type="button"
          v-for="(prop, i) in properties"
          :key="'dot-' + prop.cod_ofer"
          class="chat-carousel__dot"
          :class="{ 'is-active': i === index }"
          @click="go(i)"
          :aria-label="`Ir al inmueble ${i + 1}`"
        ></button>
      </div>

      <button
        type="button"
        class="chat-carousel__arrow"
        :disabled="index === properties.length - 1"
        @click="next"
        aria-label="Siguiente inmueble"
      >
        <span class="fa fa-chevron-right"></span>
      </button>
    </div>

    <p class="chat-carousel__counter" v-if="properties.length > 1">
      {{ index + 1 }} de {{ properties.length }} inmuebles
    </p>
  </div>
</template>

<script>
import Property from '../Property.vue'
import { prefersReducedMotion } from '../../utils/chatIntro'

export default {
  name: 'ChatPropertyCards',
  components: { Property },
  props: {
    properties: { type: Array, required: true }
  },
  data () {
    return {
      index: 0,
      reducedMotion: prefersReducedMotion()
    }
  },
  computed: {
    trackStyle () {
      return { transform: `translateX(-${this.index * 100}%)` }
    }
  },
  methods: {
    prev () { if (this.index > 0) this.index-- },
    next () { if (this.index < this.properties.length - 1) this.index++ },
    go (i) { this.index = i },
    goToDetail (prop) {
      const path = `/inmueble/${prop.cod_ofer}`
      if (this.$route.path !== path) this.$router.push(path)
      // En escritorio (dos ventanas) el panel sigue abierto a la derecha; en
      // móvil ocupa toda la pantalla, así que lo cerramos para ver el inmueble.
      if (window.innerWidth < 992) this.$store.dispatch('chat/closePanel')
    },
    visit (prop) {
      this.$store.dispatch('chat/scheduleVisit', prop.ref)
    }
  }
}
</script>

<style scoped>
.chat-carousel {
  margin-top: 10px;
}
.chat-carousel__viewport {
  overflow: hidden;
  border-radius: 12px;
}
.chat-carousel__track {
  display: flex;
  transition: transform 0.35s cubic-bezier(0.4, 0, 0.2, 1);
  will-change: transform;
}
.chat-carousel__track.is-static { transition: none; }
.chat-carousel__slide {
  flex: 0 0 100%;
  width: 100%;
  min-width: 0;
}

.chat-carousel__actions {
  display: flex;
  gap: 8px;
  margin-top: -10px;
  padding: 0 4px;
}
.chat-carousel__btn {
  flex: 1;
  border: 1px solid #E45726;
  background: #fff;
  color: #E45726;
  border-radius: 8px;
  padding: 8px 6px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s, color 0.2s;
}
.chat-carousel__btn:hover { background: #FDEDE7; }
.chat-carousel__btn--primary { background: #E45726; color: #fff; }
.chat-carousel__btn--primary:hover { background: #cc3e13; color: #fff; }

.chat-carousel__nav {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  margin-top: 10px;
}
.chat-carousel__arrow {
  width: 38px;
  height: 38px;
  border-radius: 50%;
  border: none;
  background: #1D262D;
  color: #fff;
  font-size: 15px;
  cursor: pointer;
  transition: background 0.2s, opacity 0.2s;
  flex: 0 0 auto;
}
.chat-carousel__arrow:hover:not(:disabled) { background: #E45726; }
.chat-carousel__arrow:disabled { opacity: 0.35; cursor: default; }

.chat-carousel__dots {
  display: flex;
  gap: 6px;
  align-items: center;
}
.chat-carousel__dot {
  width: 8px;
  height: 8px;
  padding: 0;
  border: none;
  border-radius: 50%;
  background: #C9CDD1;
  cursor: pointer;
  transition: background 0.2s, transform 0.2s;
}
.chat-carousel__dot.is-active {
  background: #E45726;
  transform: scale(1.3);
}

.chat-carousel__counter {
  margin: 6px 0 0;
  text-align: center;
  font-size: 12px;
  color: #98A0A6;
}
</style>
